import { AiSparkles, ChatGpt, Gemini, Perplexity } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import { AssetsService } from "app/services/AssetsService";

import type { AiAdsPlatform } from "./getAiInsightsDisplay";

export const AI_INSIGHTS_TRANSLATION_KEYS = {
    title: "wa.wwo.ai.insights.title",
    tooltip: "wa.wwo.ai.insights.tooltip",
    trafficLabel: "wa.wwo.ai.insights.traffic.label",
    trafficAfterSource: "wa.wwo.ai.insights.traffic.after_source",
    trafficLink: "wa.wwo.ai.insights.traffic.link",
    adsLabel: "wa.wwo.ai.insights.ads.label",
    adsLink: "wa.wwo.ai.insights.ads.link",
    adsAfterLink: "wa.wwo.ai.insights.ads.after_link",
    others: "wa.wwo.ai.insights.traffic.others",
    trafficLinkTooltip: "wa.wwo.ai.insights.traffic.link.tooltip",
    adsLinkTooltip: "wa.wwo.ai.insights.ads.link.tooltip",
    trafficLockedLink: "wa.wwo.ai.insights.traffic.locked.link",
    trafficLockedAfterLink: "wa.wwo.ai.insights.traffic.locked.after_link",
    adsLockedLink: "wa.wwo.ai.insights.ads.locked.link",
    adsLockedAfterLink: "wa.wwo.ai.insights.ads.locked.after_link",
    upgradeTitle: "wa.ao.conversionrate.locked.title",
    upgradeCta: "wa.ao.conversionrate.locked.cta",
} as const;

export const AI_TRAFFIC_OVERVIEW_STATE = "aitraffic.frame.overview";
export const AI_ADS_STATE = "ai-channels.ads";

export const AI_TRAFFIC_HOOK_KEY = "chatbotAITraffic";
export const AI_ADS_HOOK_KEY = "AdvertiserActivityUpgradeToTouch";

export const AI_INSIGHTS_INTERNAL_LINK_TRACKING = {
    aiSearchTraffic: "WebPerformanceAISearchTrafficLink",
    aiAds: "WebPerformanceAIAdsLink",
} as const;

const PLATFORM_LOGO_BASE = "/images/ad-intelligence/llms-channels";

export const AI_ADS_PLATFORM_META: Record<AiAdsPlatform, { nameKey: string; logo: string }> = {
    Gpt: {
        nameKey: "llm.model_selector.model.gpt",
        logo: AssetsService.assetUrl(`${PLATFORM_LOGO_BASE}/chatgpt.png`),
    },
    GoogleAiOverview: {
        nameKey: "ad.intelligence.llms.channels.promo.mockup.shoe.platform",
        logo: AssetsService.assetUrl(`${PLATFORM_LOGO_BASE}/google-ai-overview.png`),
    },
    GoogleAiMode: {
        nameKey: "llm.model_selector.model.aimode",
        logo: AssetsService.assetUrl(`${PLATFORM_LOGO_BASE}/google-ai-mode.png`),
    },
};

export const ASSISTANT_ICON_PROPS = { size: 16, color: colorsPalettes.carbon[400] } as const;

export const ASSISTANT_ICON_META: Record<string, typeof ChatGpt> = {
    ChatGPT: ChatGpt,
    Gemini: Gemini,
    Perplexity: Perplexity,
    Others: AiSparkles,
};
